const downloadURI = (uri: string, name: string): void => {
  const link = document.createElement('a');
  link.download = name;
  link.href = `${uri}-/inline/no/`;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

export default downloadURI;
